import AddUserModalSummary from './component'

export default AddUserModalSummary
